import React, { useState, useEffect } from "react";
import { taxTypeService } from "_services/taxType.service";
import {
  Breadcrumb,
  message,
  PageHeader,
  Spin,
  Table,
  Tag,
  Button,
  Popconfirm,
} from "antd";
import Page from "_components/Page";
import { Link } from "react-router-dom";
import Search from "./Search";
import { CloseOutlined } from "@ant-design/icons";

function List({ match, history }) {
  const { path } = match;
  const [loading, setLoading] = useState(false);
  const [taxTypes, setTaxTypes] = useState([]);

  useEffect(() => {
    getTaxTypes();
  }, []);

  const getTaxTypes = () => {
    setLoading(true);

    taxTypeService
      .getAll()
      .then((data) => {
        setTaxTypes(data.content);
        setLoading(false);
      })
      .catch((error) => {
        message.error(`${error}`);
        setLoading(false);
      });
  };

  const handleDelete = (id) => {
    taxTypeService
      .delete(id)
      .then(() => {
        message.success("Successfully Deleted!");
        getTaxTypes();
      })
      .catch((error) => {
        message.error(error);
      });
  };

  const getColumns = () => {
    let columns = [];

    columns.push({
      title: "Code",
      dataIndex: "code",
      key: "code",
      render: (text, record) => (
        <Link to={`${path}/${record.id}/summary`}>{text}</Link>
      ),
    });

    columns.push({
      title: "Name",
      dataIndex: "name",
      key: "name",
    });

    columns.push({
      title: "Description",
      dataIndex: "description",
      key: "description",
    });

    columns.push({
      title: "Rate",
      dataIndex: "rate",
      key: "rate",
    });

    columns.push({
      title: "Valid From",
      dataIndex: "validFrom",
      key: "validFrom",
    });

    columns.push({
      title: "Valid To",
      dataIndex: "validTo",
      key: "validTo",
    });

    columns.push({
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => {
        let color = "";
        if (text === "ACTIVE") {
          color = "#87d068";
        }

        return <Tag color={color}>{text}</Tag>;
      },
    });

    columns.push({
      title: "",
      key: "action",
      render: (text, record) => (
        <Popconfirm
          title={`Are you sure to Delete it?`}
          onConfirm={() => handleDelete(record.id)}
          placement="left"
          key="deleteBtnKey"
        >
          <CloseOutlined />
        </Popconfirm>
      ),
    });

    return columns;
  };
  const onSearchResults = (data) => {
    setTaxTypes(data);
  };

  const getActionButtons = () => {
    let buttons = [];

    buttons.push(
      <Link to={`${path}/add`} key="Add">
        <Button type="primary">Add</Button>
      </Link>
    );

    return buttons;
  };

  return (
    <PageHeader
      title={
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to={"/dashboard"}>Dashboard</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to={"/tax-types"}>Tax Type</Link>
          </Breadcrumb.Item>
        </Breadcrumb>
      }
      extra={getActionButtons()}
    >
      <Page>
        <Search
          onSearchResults={onSearchResults}
          showSearchLoading={setLoading}
        />
        <Spin spinning={loading}>
          <Table columns={getColumns()} dataSource={taxTypes}></Table>
        </Spin>
      </Page>
    </PageHeader>
  );
}

export default List;
